module.exports = __webpack_public_path__ + "img/blue_033.2a69be89.png";